// @flow
import axios from 'lib/defaultClient';

export type WriteCommentPayload = {
  productId: string,
  text: string,
  replyTo?: ?string,
};

export const writeComment = ({ productId, text, replyTo }: WriteCommentPayload) =>
  axios.post(`/products/${productId}/comments`, {
    text,
    reply_to: replyTo,
  });

export type ReadCommentsPayload = {
  productId: string,
};

export const readComments = ({ productId }: ReadCommentsPayload) =>
  axios.get(`/products/${productId}/comments`);

export type ReadSubCommentsPayload = {
  productId: string,
  commentId: string,
  parentId?: ?string,
};

export const readSubComments = ({ productId, commentId }: ReadSubCommentsPayload) =>
  axios.get(`/products/${productId}/comments/${commentId}/replies`);

export type RemoveCommentPayload = {
  productId: string,
  commentId: string,
};

export const removeComment = ({ productId, commentId }: RemoveCommentPayload) => {
  return axios.delete(`/products/${productId}/comments/${commentId}`);
};

export type EditCommentPayload = {
  productId: string,
  commentId: string,
  text: string,
  parentId: ?string,
};

export const editComment = ({ productId, commentId, text }: EditCommentPayload) =>
  axios.patch(`/products/${productId}/comments/${commentId}`, { text });



// WEBPACK FOOTER //
// ./src/lib/api/products/comments.js